import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { AccountService } from 'src/app/account/services/account.service'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'subscription-overage-issue',
  templateUrl: './subscription-overage-issue.component.html',
  styleUrls: ['./subscription-overage-issue.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SubscriptionOverageIssueComponent implements OnInit {
  constructor(
    public uiService: UiService,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {}

  get accountSettingsUrl() {
    return this.uiService.buildAccountSettingsUrl(this.accountService.accountId)
  }
}
